// CompaniesServiceProvider.tsx
import { getAll, getOne } from '../services/CRUDServiceProvider';
import { PaginatedResponse } from '../types/pagination';
import { PaginationRequest } from '../types/pagination';

let url_path = 'companies';
let url_location_path = 'location/company';

export interface Company {
    slug: string | null;
    name: string;
    email: string;
    latitude: number;
    longitude: number;
    address: string | null;
    phone_number: string | null;
    facebook_link: string | null;
    instagram_link: string | null;
    youtube_link: string | null;
    status: string;
};

export interface CompanyLocation {
    map: string;
}

export const getAllCompanies = async (pagination: PaginationRequest): Promise<PaginatedResponse<Company>> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getAll<any>(url_path, pagination, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCompanyLocation = async (slug: string, popup: string): Promise<CompanyLocation> => {
    console.log(url_location_path);
    try {
        const response = await getOne<any>(url_location_path, slug, undefined, popup);
        return response.data;
    } catch (error) {
        throw error;
    }
}
